import React, { useState, useCallback } from 'react'
import { FormControl, FormLabel, Input, FormErrorMessage } from '@chakra-ui/react'
import { validateCardNumber } from '../validators/cardValidator'

export const CardNumberInput = ({ onChange }) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState(null)
  const [touched, setTouched] = useState(false)

  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value.replace(/\D/g, '')
      if (newValue.length <= 19) {
        setValue(newValue)
        // エラーがある場合のみクリア
        if (error) {
          setError(null)
        }
        // 親に通知
        const validationError = validateCardNumber(newValue)
        if (onChange) {
          onChange(newValue, !validationError)
        }
      }
    },
    [error, onChange],
  )

  const handleBlur = useCallback(() => {
    setTouched(true)
    const validationError = validateCardNumber(value)
    setError(validationError)
    // 親に最新の状態を通知
    if (onChange) {
      onChange(value, !validationError)
    }
  }, [value, onChange])

  return (
    <FormControl isInvalid={touched && !!error}>
      <FormLabel fontSize="xs" fontWeight="600" mb="8px" color="externalPayment.cardInputText">
        クレジットカード番号
      </FormLabel>
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="ハイフンなし、半角数字で入力してください。"
        bg="bg.secondary"
        borderRadius="4px"
        h="40px"
        fontSize="3xs"
        fontWeight="300"
        inputMode="numeric"
        maxLength={19}
        borderWidth="1px"
        borderColor="externalPayment.cardInputBorder"
        _placeholder={{ color: 'externalPayment.cardInputPlaceholder' }}
        _hover={{ borderColor: 'externalPayment.cardInputBorderHover' }}
        _focus={{ borderColor: 'externalPayment.cardInputBorderFocus', boxShadow: 'none' }}
      />
      {touched && error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  )
}
